import type { AnalyticsProvider } from "./provider";

// Single injected provider. Until an app calls setProvider, all tracking is a silent no-op
// (preserves the "fire nothing until configured" guarantee).
let provider: AnalyticsProvider | null = null;

export function setProvider(p: AnalyticsProvider): void {
  provider = p;
}

export function getProvider(): AnalyticsProvider | null {
  return provider;
}
